import React from 'react';
export function TopBar() {
  return <div className="bg-brand-mint text-brand-ink text-center py-3.5 px-5" data-id="element-172">
      <p className="font-display font-bold md:text-lg tracking-wide text-[18px]" data-id="element-173">
        ⚡ SOLO POR HOY: SISTEMA CÓDIGO SENSORIAL TEA® + 6 BONOS GRATIS —
      </p>
    </div>;
}